import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectIsAuthenticated,
  selectUserType,
  selectIsLoading,
  restoreAuth,
} from '../../redux/slices/authSlice';

const ProtectedRoute = ({ children, requiredUserType = null, redirectTo = '/' }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const userType = useSelector(selectUserType);
  const isLoading = useSelector(selectIsLoading);

  // Intentar restaurar sesión desde localStorage al montar
  useEffect(() => {
    if (!isAuthenticated) {
      const userData = localStorage.getItem('user');
      if (userData) {
        try {
          const parsedUserData = JSON.parse(userData);
          dispatch(restoreAuth(parsedUserData));
        } catch (error) {
          console.error('Error al restaurar sesión:', error);
          localStorage.removeItem('user');
        }
      }
    }
  }, [isAuthenticated, dispatch]);

  // Mostrar loading mientras verifica autenticación
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Si se requiere un tipo específico de usuario y no coincide
  if (requiredUserType && userType !== requiredUserType) {
    // Redirigir al dashboard correspondiente del usuario actual
    const correctDashboard = userType === 'lawyer' ? '/lawyer-dashboard' : '/client-dashboard';
    return <Navigate to={correctDashboard} replace />;
  }

  // Usuario autenticado y con permisos correctos
  return children;
};

export default ProtectedRoute;
